import api from "@/auth/api";

const BASE_URL =
  "/pos/sales";

async function createSale(
  payload
) {
  const response =
    await api.post(
      BASE_URL,
      payload
    );

  return response.data;
}

async function getSale(
  saleId
) {
  const response =
    await api.get(
      `${BASE_URL}/${saleId}`
    );

  return response.data;
}

async function payCash(
  saleId,
  payload
) {
  const response =
    await api.post(
      `${BASE_URL}/${saleId}/payments/cash`,
      payload
    );

  return response.data;
}

export default {
  createSale,
  getSale,
  payCash
};